import styled from 'styled-components'

export const NewsWidgetCard = styled.div`
  background: ${props => props.theme?.secondColor};
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  padding: 20px;
  grid-column: 1 / -1;
`

export const NewsTitle = styled.h2`
  color: white;
  font-size: 28px;
  font-weight: 400;
  margin: 0;
`

export const NewsCarouselHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`

export const NewsCarouselButton = styled.button<{ disabled?: boolean }>`
  background: white !important;
  border: none;
  border-radius: 50%;
  width: 45px;
  position: absolute;
  height: 45px;
  z-index: 9999;
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  opacity: ${props => (props.disabled ? 0.4 : 1)};
  transition: background-color 0.2s ease;
  margin-left: 8px;

  &:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.3);
    i.icon {
      color: white !important;
      margin: 0 !important;
    }
  }

  i.icon {
    margin: 0 !important;
  }
`

export const NewsCarouselContainer = styled.div`
  overflow: hidden;
  width: 100%;
  position: relative;

  .right-carousel {
    right: 0px;
    top: calc(50% - 35px);
  }

  .left-carousel {
    left: 0px;
    top: calc(50% - 35px);
  }
`

export const NewsCarouselTrack = styled.div`
  display: flex;
  gap: 20px;
  transition: transform 0.3s ease-in-out;
  padding: 0px 50px;
`

export const NewsSection = styled.div<{$backgroundImage?: any}>`
  flex: 0 0 280px;
  min-width: 280px;
  background-color: rgb(208, 146, 149);
  background-image: ${props => props.$backgroundImage ? `url(${props.$backgroundImage})` : 'none'};
  background-repeat: no-repeat;
  background-position: bottom;
  background-size: contain;
  border-radius: 4px;
  padding: 15px;
`

export const NewsSectionTitle = styled.h3`
  color: black;
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 5px 0;
`

export const NewsSectionDate = styled.span`
  color: black;
  font-size: 12px;
  display: block;
  margin-bottom: 10px;
`

export const NewsSectionDescription = styled.p`
  color: black;
  font-size: 13px;
  margin: 0 0 12px 0;
  line-height: 1.4;
`

export const NewsActionsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`

export const NewsActionButton = styled.div`
  display: inline-block;
  background: rgba(255, 255, 255, 0.15);
  color: black;
  font-size: 12px;
  padding: 6px 12px;
  border-radius: 4px;
  text-decoration: none;
  transition: background-color 0.2s ease;
  cursor: pointer;

  &:hover {
    background: rgba(255, 255, 255, 0.25);
    color: black;
  }
`
